import React, { useState, useEffect } from 'react';
import ImageUploader from 'react-image-upload';
import 'react-image-upload/dist/index.css';

const Placeholderimage = () => {
  const [name, setName] = useState('');
  const [alt, setAlt] = useState('');
  const [imageFile, setImageFile] = useState(null);
  const [message, setMessage] = useState('');
  const [id, setId] = useState(null); // State to store the ID for updates

  // Fetch existing placeholder image data from the API and populate form fields
  useEffect(() => {
    const fetchImageData = async () => {
      try {
        const response = await fetch("https://api.experts4u.in/api/v1/placeholderimage/placeholderimage", {
          method: "GET",
          headers: {
            "Authorization": "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiI2NmQyZjg1NjlhZWFlNDQzYWY1MDQ1MWQiLCJyb2xlIjowLCJwZXJtaXNzaW9ucyI6W10sImlhdCI6MTczMDI2NTE0M30.lXYvhEtNEdYD9FkA5YlQpQeAX4hayoQhbXVpvoSiOBQ",
          },
        });

        const result = await response.json();
        if (response.ok && result.length > 0) {
          const imageData = result[0]; // Assuming we only display the first item
          setId(imageData._id);
          setName(imageData.name);
          setAlt(imageData.alt);
          setImageFile({ file: { name: imageData.image }, dataURL: imageData.image });
        } else {
          setMessage("Failed to fetch image data.");
        }
      } catch (error) {
        console.error("Error:", error);
        setMessage("Server error");
      }
    };

    fetchImageData();
  }, []);

  const getImageFileObject = (imageFile) => {
    setImageFile(imageFile);
    console.log("Image added:", imageFile);
  };

  const runAfterImageDelete = (file) => {
    setImageFile(null);
    console.log("Image removed:", file);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!name || !alt || !imageFile) {
      setMessage('Please provide name, alt text, and an image.');
      return;
    }

    const formData = new FormData();
    formData.append('name', name);
    formData.append('alt', alt);
    formData.append('image', imageFile.file); // Access the file property
    if (id) formData.append('id', id); // Include id for updates if available

    try {
      const response = await fetch("https://api.experts4u.in/api/v1/placeholderimage/placeholderimage", {
        method: "POST",
        headers: {
          "Authorization": "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiI2NmQyZjg1NjlhZWFlNDQzYWY1MDQ1MWQiLCJyb2xlIjowLCJwZXJtaXNzaW9ucyI6W10sImlhdCI6MTczMDI2NTE0M30.lXYvhEtNEdYD9FkA5YlQpQeAX4hayoQhbXVpvoSiOBQ",
        },
        body: formData,
        redirect: "follow"
      });

      const result = await response.json();
      if (response.ok) {
        setMessage(id ? 'Image updated successfully!' : 'Image uploaded successfully!');
      } else {
        setMessage(result.message || 'Failed to upload image.');
      }
    } catch (error) {
      console.error("Error:", error);
      setMessage('Server error');
    }
  };

  return (
    <div className='app has-fullwidth'>
      <div className="app-main">
        <div className="container mt-4">
          <div className="card shadow-lg">
            <div className="card-header text-center">
              <h4 className="card-title mb-0">Upload Placeholder Image</h4>
            </div>
            <div className="card-body">
              <form onSubmit={handleSubmit}>
                <div className="form-group mb-3">
                  <label>Name</label>
                  <input
                    type="text"
                    className="form-control"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    required
                  />
                </div>
                <div className="form-group mb-3">
                  <label>Alt Text</label>
                  <input
                    type="text"
                    className="form-control"
                    value={alt}
                    onChange={(e) => setAlt(e.target.value)}
                    required
                  />
                </div>
                <div className="form-group mb-3">
                  <label>Upload Image</label>
                  <ImageUploader
                    onFileAdded={getImageFileObject}
                    onFileRemoved={runAfterImageDelete}
                    initialImage={imageFile ? imageFile.dataURL : null}
                  />
                </div>
                <button type="submit" className="btn btn-primary btn-block">{id ? 'Update' : 'Submit'}</button>
              </form>
              {message && <div className="alert alert-info mt-3">{message}</div>}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Placeholderimage;
